import React from 'react'
import { H } from 'react-document-section'

import { headingBlock } from './index.module.scss'

const HeadingBlock = ({ slugified }: { slugified: string }) => {
  return <H id={slugified} className={headingBlock} />
}

export default HeadingBlock
